module.exports = __webpack_public_path__ + "img/journey-01.0e433127.png";